import { Injectable } from '@angular/core';
import { Validators } from '@angular/forms';
import {
    BaseControl,
    Textbox,
    Radio,
    Dropdown,
    TextArea,
    Typeahead,
    Custom
  } from '@app/shared';


@Injectable()
export class ManageFunctionFormService {
  constructor() {}
  /**
   * Refactoriza el formulario de agregar funcion
   *
   * @param {*} [tramites]
   * @param {*} [objectModel]
   * @returns {BaseControl<any>[]}
   * @memberof ManageFunctionFormService
   */
  getFormFunction(ngSelectTpl: any): BaseControl<any>[] {
    const controls: BaseControl<any>[] = [
      new Custom({
        key: 'cboFuncion',
        label: 'Funciones:',
        order: 1,
        size: 'col-12',
        template: ngSelectTpl,
        placeholder: 'Seleccione una función',
        validations: {
          validators: [Validators.required]
        }
      }),
      new Textbox({
        key: 'chkObligatorio',
        type: 'checkbox',
        label: 'Obligatorio:',
        value: false
      }),
    ];

    return controls.sort((a, b) => a.order - b.order);
  }
}



// WEBPACK FOOTER //
// ./src/app/administration/process-automation/manage-function/shared/manage-function.form.service.ts